<template>
  <div id = "cameraconection">
    <div class = "bar">
      <span class = "material-icons md-24">videocam</span>
      <button v-if = "connected" v-on:click = "stop()" class = "btn btn-bg-colored">Desconectar</button>
    </div>
    <p>Socket: {{this.connected}}</p>
    <p>Messages: {{this.messagecount}}</p>
  </div>
</template>

<script>
/* eslint-disable */
import io from 'socket.io-client'

export default {
  name: 'ApiMplTrackingCamera',
  watch: {
    'editorConfig.isSketchRunning': function (isSketchRunning) {
      console.log('isSketchRunning ' + isSketchRunning)
      if (isSketchRunning === true) {
        this.play()
      } else {
        this.stop()
      }
    }
  },
  methods: {
    connect () {
      console.log('connect')
      // si no estamos conectados
      if (!this.connected === true) {
        this.init()
      }
    },
    stop () {
      console.log('disconnect')
      if (this.socket) this.socket.disconnect()
      this.connected = false
    },
    play () {
      this.connect()
    },
    init () {
      // connect to localhost presently
      this.socket = new io.connect('http://127.0.0.1:2525')
      this.connected = true
      console.log('empezando')
      this.socket.on('updateClient', this.processmsg)
    },
    processmsg (currentMsg) {
      const correctionY = 192 / 320
      const correctionX = 157 / 240
      this.messagecount++

      if (typeof currentMsg.blobs !== 'undefined') {
        let currB = currentMsg.blobs
        let modB = []
        for (var i = 0; i < currB.length; i += 1) {
          modB[i] = {}
          modB[i].id = currB[i].id
          modB[i].x = Math.round(currB[i].x * correctionX)
          modB[i].y = Math.round(currB[i].y * correctionY)
        }
        this.$eventHub.$emit('rtdata', { from: 'onNewBlobs', value: modB })
      }
    }
  },
  data () {
    return {
      isPlaying: false,
      isRepeatingVideo: false,
      socket: null,
      connected: false,
      messagecount: 0
    }
  },
  computed: {
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  beforeDestroy () {
    this.stop()
  }
}
</script>

<style lang="less" scoped>

#cameraconection {
  padding: 10px;
}

.bar {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
}

button {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectPlayer/ApiMlpTrackingCamera.vue